var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('maz-session-time-out-counter',{attrs:{"is-inactive":_vm.isInactive}})}
var staticRenderFns = []

export { render, staticRenderFns }